export default "__VITE_ASSET__CQWNIJDe__"